import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@els/els-react--checkbox';
import { Pill } from '@els/els-react--pill';

import './SelectedItemsControls.scss';

export default function SelectedItemsControls(props) {
  const { checkAllItems, allItemsSelected, someItemsSelected, currentSelectedItems } = props;

  return (
    <div className="selected-items-controls-wrapper">
      <Checkbox
        title="Select all"
        className="selected-items-controls-checkbox e2e-allResults"
        onChange={() => {
          checkAllItems(!allItemsSelected);
        }}
        data-e2e="select-all"
        checked={allItemsSelected}
        indeterminate={someItemsSelected}
        ariaControlsGuidance={`${currentSelectedItems} items selected`}
      />
      <Pill condensed>{`${currentSelectedItems || 0}`}</Pill>
      <span className="u-els-display-none@desktop u-els-margin-left-1o2">selected</span>
    </div>
  );
}

SelectedItemsControls.propTypes = {
  checkAllItems: PropTypes.func.isRequired,
  allItemsSelected: PropTypes.bool.isRequired,
  someItemsSelected: PropTypes.bool,
  currentSelectedItems: PropTypes.number.isRequired,
};
